import React from 'react';
import { useTranslation } from 'react-i18next';

import SlideDialogV from '../../components/common/SlideDialogV';
import Typography from '../../components/common/Typography';
import BulletList from '../../components/common/BulletList';

const ConfirmDialog = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation('previousEmployment');

  const bulletItems = [
    t('confirmDialog.item1'),
    t('confirmDialog.item2'),
    t('confirmDialog.item3'),
  ];

  const innertComponent = (
    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
      <Typography variant="body1Bold">{t('confirmDialog.subtitle')}</Typography>
      <BulletList textAlign="left" flexColumn>
        {bulletItems.map((item, index) => (
          <li key={index}>
            <Typography variant="body1Medium">{item}</Typography>
          </li>
        ))}
      </BulletList>
    </div>
  );

  const buttons = [
    {
      label: t('confirmDialog.confirmButton'),
      onClick: onConfirm,
      color: 'primary',
    },
    {
      label: t('confirmDialog.cancelButton'),
      onClick: onClose,
      color: 'secondary',
    },
  ];

  return (
    <SlideDialogV
      isOpen={isOpen}
      onClose={onClose}
      title={t('confirmDialog.title')}
      innertComponent={innertComponent}
      buttons={buttons}
    />
  );
};

export default ConfirmDialog;
